module.exports = __webpack_public_path__ + "static/media/form-continue-button.1b225e6c.png";